import { variables } from './shared';

export const {
  headerRowBackgroundColor,
  headerRowBorderTop,
  headerRowBorderBottom,
  totalRowBackgroundColor,
  totalRowBorderTop,
  tableBorder,
  gridPaddingLeft,
  gridPaddingComponsation,
} = variables;
